/**
 * external window dependencies:
 * - slicknav
 **/
let createMobileMenu = (el, appendTo) => {
    $(el).slicknav({
        label: '',
        appendTo: appendTo
    });
};


module.exports = createMobileMenu;


// WEBPACK FOOTER //
// ./assets/js/app/lib/mobile-menu.js